<template>
  <v-img
    width="100%"
    v-bind="$attrs"
    :aspect-ratio="1"
    contain
    :src="`https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${data}&choe=UTF-8`"
  >
    <template #placeholder>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular indeterminate color="primary500" />
      </v-row>
    </template>
  </v-img>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      required: true,
    },
  },
}
</script>
